export const MessageType = {
  REGISTRATION_SUCCESSFUL: 0,
  EMAIL_VERIFIED: 1,
  DOCUMENTS_SUBMITTED: 2,
  CENTER_REGISTRATION_SUCCESSFUL: 3,
};


export const RegistrationStatus = {
  NOT_REQUESTED: 0,
  APPROVED: 1,
  REJECTED: 2,
  PENDING: 3,
  ALREADY_CONFIRMED:4
};
